module.exports = __webpack_public_path__ + "img/logo_zc.6484abaf.png";